import { IconButton, Stack, Text } from "@fluentui/react";
import { BreakpointType } from "../Container/ContainerFluid";
import { useBreakpoint } from "../Container/ContainerStyles";
import { lgRegisterConfigurationUserInputNumberStyles, lgRegisterConfigurationUserInputTitleStyles, mdRegisterConfigurationUserInputNumberStyles, mdRegisterConfigurationUserInputTitleStyles, registerConfigurationUserInputContainerStyles, registerConfigurationUserInputNumberStyles, registerConfigurationUserInputTitleStyles, smRegisterConfigurationUserInputNumberStyles, smRegisterConfigurationUserInputTitleStyles, xlRegisterConfigurationUserInputNumberStyles, xlRegisterConfigurationUserInputTitleStyles, xxlRegisterConfigurationUserInputNumberStyles, xxlRegisterConfigurationUserInputTitleStyles } from "../Register/Components/Configuration/Styles/RegisterConfigurationStyles";
import { RegisterService } from "../Register/Service/RegisterService";

export interface ICommonConfigurationUserInputProps {
    userNo: number;
    onChange: (userNo: number) => void;
}

export const CommonConfigurationUserInput: React.FC<ICommonConfigurationUserInputProps> = (props) => {
    const isSM = useBreakpoint(BreakpointType.sm);
    const isMD = useBreakpoint(BreakpointType.md);
    const isLG = useBreakpoint(BreakpointType.lg);
    const isXL = useBreakpoint(BreakpointType.xl);
    const isXXL = useBreakpoint(BreakpointType.xxl);

    return (
        <Stack
            horizontal
            horizontalAlign="space-between"
            verticalAlign="center"
            verticalFill
            className={registerConfigurationUserInputContainerStyles}
        >
            <Stack>
                <Text
                    className={
                        isSM ?
                            smRegisterConfigurationUserInputTitleStyles :
                        isMD ?
                            mdRegisterConfigurationUserInputTitleStyles :
                        isLG ?
                            lgRegisterConfigurationUserInputTitleStyles :
                        isXL ?
                            xlRegisterConfigurationUserInputTitleStyles :
                        isXXL ?
                            xxlRegisterConfigurationUserInputTitleStyles
                        :
                            registerConfigurationUserInputTitleStyles
                    }
                >    
                    {RegisterService.translate("configuration:users")}
                </Text>
            </Stack>
            <Stack
                horizontal
                horizontalAlign="center"
                verticalAlign="center"
                verticalFill
            >
                <IconButton 
                    iconProps={{ iconName: 'Remove' }}
                    onClick={() => props.onChange(props.userNo - 1)}
                />
                <Text
                    className={
                        isSM ?
                            smRegisterConfigurationUserInputNumberStyles :
                        isMD ?
                            mdRegisterConfigurationUserInputNumberStyles :
                        isLG ?
                            lgRegisterConfigurationUserInputNumberStyles :
                        isXL ?
                            xlRegisterConfigurationUserInputNumberStyles :
                        isXXL ?
                            xxlRegisterConfigurationUserInputNumberStyles
                        :
                            registerConfigurationUserInputNumberStyles
                    }
                >
                    {props.userNo}
                </Text>
                <IconButton
                    styles={{}}
                    iconProps={{ iconName: 'Add' }}
                    onClick={() => props.onChange(props.userNo + 1)}
                />
            </Stack>
        </Stack>
    );
};